var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTikTokIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6587_243449)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 7,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.458 20.6228C39.5266 20.6228 38.6044 20.4393 37.7439 20.0829C36.8834 19.7265 36.1015 19.2041 35.443 18.5455C34.7844 17.8869 34.262 17.1051 33.9055 16.2446C33.5491 15.3841 33.3657 14.4619 33.3657 13.5305H28.2987V33.372C28.2977 34.2766 28.012 35.158 27.4822 35.8912C26.9523 36.6244 26.2052 37.1722 25.3466 37.4571C24.488 37.7419 23.5615 37.7493 22.6985 37.4781C21.8354 37.207 21.0796 36.6712 20.5382 35.9465C19.9967 35.2218 19.697 34.3451 19.6817 33.4406C19.6663 32.5361 19.936 31.6498 20.4525 30.9071C20.969 30.1645 21.7062 29.6032 22.5595 29.3029C23.4128 29.0026 24.339 28.9785 25.2068 29.234V24.3085C23.3626 24.0599 21.4864 24.3797 19.8288 25.2254C18.1712 26.0711 16.811 27.4024 15.9299 29.0415C15.0488 30.6806 14.6887 32.5494 14.8977 34.3986C15.1067 36.2477 15.8749 37.989 17.0996 39.3901C18.3244 40.7912 19.9474 41.7852 21.752 42.2396C23.5565 42.6939 25.4568 42.5869 27.1989 41.9329C28.9411 41.2788 30.4423 40.1088 31.502 38.5792C32.5617 37.0495 33.1295 35.2329 33.1297 33.372L33.2767 23.3427C35.3586 24.871 37.8747 25.6934 40.4574 25.6896L40.458 20.6228Z",
    fill: "url(#paint0_linear_6587_243449)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1179 19.2425C37.2369 19.2424 35.433 18.4952 34.103 17.1651C32.773 15.835 32.0258 14.0311 32.0258 12.1501H26.9588V31.9916C26.9579 32.8962 26.6723 33.7776 26.1424 34.5108C25.6126 35.244 24.8654 35.7919 24.0068 36.0767C23.1482 36.3616 22.2217 36.369 21.3587 36.0979C20.4956 35.8268 19.7398 35.2909 19.1983 34.5662C18.6569 33.8416 18.3572 32.9649 18.3418 32.0604C18.3265 31.1559 18.5961 30.2695 19.1127 29.5268C19.6292 28.7842 20.3664 28.2229 21.2197 27.9226C22.073 27.6223 22.9992 27.5982 23.867 27.8537V22.9282C22.0228 22.6795 20.1466 22.9993 18.489 23.845C16.8313 24.6907 15.4712 26.022 14.5901 27.6611C13.7089 29.3002 13.3489 31.1691 13.5579 33.0182C13.7669 34.8673 14.535 36.6086 15.7598 38.0097C16.9845 39.4108 18.6075 40.4048 20.4121 40.8592C22.2167 41.3135 24.1169 41.2065 25.8591 40.5525C27.6013 39.8984 29.1025 38.7285 30.1622 37.1988C31.2219 35.6691 31.7897 33.8525 31.7898 31.9916L31.9376 21.9624C34.0195 23.4907 36.5357 24.313 39.1184 24.3092L39.1179 19.2425Z",
    fill: "url(#paint1_linear_6587_243449)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1171 20.4959C37.364 20.1586 35.8025 19.1725 34.7445 17.7345C33.4073 16.6879 32.49 15.1962 32.1596 13.5305H28.2976V33.372C28.2975 34.3137 27.9893 35.2295 27.42 35.9796C26.8507 36.7297 26.0516 37.2729 25.1446 37.5263C24.2377 37.7797 23.2727 37.7294 22.3971 37.383C21.5214 37.0367 20.7831 36.4133 20.2949 35.6081C19.4268 35.043 18.7909 34.1844 18.5036 33.1892C18.2162 32.194 18.2965 31.1286 18.7299 30.1877C19.1632 29.2468 19.9206 28.4933 20.8637 28.0648C21.8067 27.6362 22.8725 27.5613 23.8662 27.8538V24.2291C22.1618 24.2511 20.4973 24.7491 19.0608 25.6668C17.6244 26.5846 16.473 27.8856 15.7368 29.423C15.0005 30.9605 14.7087 32.6731 14.8942 34.3676C15.0796 36.0621 15.7351 37.671 16.7866 39.0127C18.1214 40.1266 19.7461 40.8368 21.4702 41.0601C23.1943 41.2835 24.9463 41.0107 26.5209 40.2738C28.0955 39.5369 29.4274 38.3664 30.3605 36.8995C31.2935 35.4326 31.7891 33.7302 31.7891 31.9917L31.9369 21.9624C34.0188 23.4907 36.535 24.3131 39.1176 24.3092L39.1171 20.4959Z",
    fill: "url(#paint2_linear_6587_243449)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6587_243449",
    x1: 16.8706,
    y1: 39.189,
    x2: 37.9474,
    y2: 18.1121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5053C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233,
    stopColor: "#C90441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#F0014B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF004F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6587_243449",
    x1: 15.2167,
    y1: 38.1223,
    x2: 37.4184,
    y2: 15.9207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#00C8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#00E6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F1EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6587_243449",
    x1: 2.77751,
    y1: 51.9208,
    x2: 51.9211,
    y2: 2.77721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF7F7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6587_243449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 6,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTokIcon);
export default __webpack_public_path__ + "static/media/tik-tok-icon.d2e65e000cfddb7254a7f724fee7c09b.svg";
export { ForwardRef as ReactComponent };